import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-polls-section-dialog',
  templateUrl: 'dialog.component.html',
})
export class PollsSectionDialogComponent implements OnInit {

  loading: boolean;
  sessions: string;
  session: string;

  constructor(
    public dialogRef: MatDialogRef<PollsSectionDialogComponent>,
    public dataService: DataService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.getSessions();
  }

  getSessions() {
    this.dataService.pollSection()
      .subscribe((response: any) => {
        this.loading = false;
        this.sessions = response;
        console.log('this.sessions', this.sessions);
      });
  }

  selectSession(session: any) {
    this.dialogRef.close(session);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
